import React from 'react';
import { NavBar } from './components/NavBar';
import { HeroSection } from './components/HeroSection';
import { DiagnosisSection } from './components/DiagnosisSection';
import { SystemSection } from './components/SystemSection';
import { SocialProofSection } from './components/SocialProofSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { ContactFormSection } from './components/ContactFormSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <main className="min-h-screen bg-carbon font-body text-white selection:bg-gold selection:text-carbon" data-id="element-0">
      <NavBar data-id="element-1" />
      <HeroSection data-id="element-2" />
      <SocialProofSection data-id="element-3" />
      <DiagnosisSection data-id="element-4" />
      <SystemSection data-id="element-5" />
      <GuaranteeSection data-id="element-6" />
      <FinalCTA data-id="element-7" />
      <ContactFormSection data-id="element-8" />
      <Footer data-id="element-9" />
    </main>;
}